import type { HorizonColorStyle } from './config'

/** Shared neutrals + project success/error (DESIGN_AIRBNB.md §2). */
const HORIZON_NEUTRALS = {
  on_primary: '#FFFFFF',
  background: '#FFFFFF',
  surface: '#FAFAFA',
  surface_strong: '#F0F0F0',
  border: '#DDDDDD',
  border_soft: '#EBEBEB',
  border_strong: '#B0B0B0',
  text_primary: '#222222',
  text_secondary: '#717171',
  text_muted: '#8C8C8C',
  muted: '#F0F0F0',
  success: '#0B7A72',
  success_soft: '#E8F5F3',
  warning: '#B45309',
  warning_soft: '#FEF3C7',
  error: '#A03434',
  error_soft: '#FEE2E2',
  scrim: 'rgb(0 0 0 / 50%)',
} as const

/** Style A - warm (DESIGN_AIRBNB.md §2). */
export const HORIZON_PALETTE_WARM = {
  primary: '#E0562A',
  primary_hover: '#A63A18',
  primary_active: '#A63A18',
  primary_disabled: '#F7D3C4',
  primary_strong: '#C4471E',
  primary_soft: '#FCEAE3',
  secondary: '#C4471E',
  secondary_hover: '#A63A18',
  secondary_soft: '#FCEAE3',
  accent: '#E0562A',
  accent_soft: '#FCEAE3',
  surface_tint: '#FCEAE3',
  ring: '#E0562A',
  info: '#C4471E',
  info_soft: '#FCEAE3',
  ...HORIZON_NEUTRALS,
} as const

/** Style B - cool / CSE Boost default (DESIGN_AIRBNB.md §2). */
export const HORIZON_PALETTE_COOL = {
  primary: '#1D7A8C',
  primary_hover: '#0F4A55',
  primary_active: '#0F4A55',
  primary_disabled: '#C7E2E6',
  primary_strong: '#155F6D',
  primary_soft: '#E3F1F3',
  secondary: '#155F6D',
  secondary_hover: '#0F4A55',
  secondary_soft: '#E3F1F3',
  accent: '#1D7A8C',
  accent_soft: '#E3F1F3',
  surface_tint: '#E3F1F3',
  ring: '#1D7A8C',
  info: '#155F6D',
  info_soft: '#E3F1F3',
  ...HORIZON_NEUTRALS,
} as const

export type HorizonPalette = Record<keyof typeof HORIZON_PALETTE_COOL, string>

export function getHorizonPalette(style: HorizonColorStyle): HorizonPalette {
  return style === 'warm' ? { ...HORIZON_PALETTE_WARM } : { ...HORIZON_PALETTE_COOL }
}
